import moment from "moment";

// Formats a UTC timestamp (as stored/returned by the backend) into the viewer's LOCAL time.
// Returns a placeholder for empty/unset values. Use for plain-text contexts (e.g. detail rows).
export function formatDateTimeLocal(value: unknown, format = "DD/MM/YYYY HH:mm:ss", emptyPlaceholder = "—") {
    if (!value || !moment(value as moment.MomentInput).isAfter(moment.utc("0001-01-01"))) {
        return emptyPlaceholder;
    }
    return moment.utc(value as moment.MomentInput).local().format(format);
}

export function dateBodyTemplate(field: string, format = "DD/MM/YYYY HH:mm:ss") {
    return (rowData: any) => {
        const value = rowData[field];
        if (!value || !moment(value).isAfter(moment.utc("0001-01-01"))) return "";
        return <span>{moment.utc(value).local().format(format)}</span>;
    };
}
